import { useEffect, useState } from 'react';
import Select from 'react-select';

import './staffing-select.scss';

import { getStaffingsBySection } from '~modules/staffing/api';
import { StaffingDto } from '~modules/staffing/dto';

interface StaffingSelectProps {
	sectionId: number;
	departmentId: string;
	organizationId: string;
	defaultValue?: StaffingDto | null;
	className?: string;
	defaultOptions: StaffingDto[];
	isDisabled: boolean;
	onBlur?: () => void;
	onChange: (value: StaffingDto) => void;
}

export const StaffingSelect = ({
	defaultOptions,
	defaultValue,
	sectionId,
	departmentId,
	organizationId,
	isDisabled,
	className = '',
	onChange,
	onBlur,
}: StaffingSelectProps) => {
	const [value, setValue] = useState<StaffingDto | null>(defaultValue ?? null);
	const [options, setOptions] = useState<StaffingDto[]>(defaultOptions);
	const [isLoading, setIsLoading] = useState(false);
	useEffect(() => {
		setValue(defaultValue ?? null);
	}, [defaultValue]);

	const loadOptions = async () => {
		if (!sectionId) {
			if (value) setOptions([value]);
			return;
		}
		setIsLoading(true);
		try {
			const result = await getStaffingsBySection(sectionId, departmentId, organizationId);
			setOptions(result);
		} catch (error) {
			console.error('Error loading options:', error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleChange = (staff: StaffingDto | null) => {
		setValue(staff);

		if (staff) {
			onChange(staff);
		}
	};

	const handleMenuOpen = () => {
		loadOptions();
	};

	return (
		<Select<StaffingDto>
			value={value}
			styles={{
				container: provided => ({
					...provided,
					width: '100%',
				}),
			}}
			className={`staffing-select ${className} ${isDisabled ? 'disabled' : ''}`}
			classNamePrefix="react-select"
			options={options}
			getOptionLabel={option => option.position!.name}
			getOptionValue={option => `${option.id}`}
			onChange={handleChange}
			onBlur={onBlur}
			isDisabled={isDisabled}
			isClearable={false}
			isLoading={isLoading}
			onMenuOpen={handleMenuOpen}
			placeholder="Выберите опцию..."
			noOptionsMessage={() => 'Нет доступных опций'}
		/>
	);
};
